<template>
  <div class="row-content ma-0 pa-0">
    <v-row class="ma-0 pa-0" justify="center">
      <v-col class="ma-0 pa-2" cols="12" sm="12" md="6" lg="5" xl="4">
        <v-card variant="outlined" :class="isOnMobile ? 'ma-0 pa-0' : 'ma-2 pa-0'" :height="isOnMobile ? 220 : 260">
          <chart-simple-donut v-if="datatypeChartMonthly" :datatype="datatypeChartMonthly" class="ma-2 pa-0"></chart-simple-donut>
        </v-card>
      </v-col>
      <v-col class="ma-0 pa-2" cols="12" sm="12" md="6" lg="7" xl="8" v-if="!isOnMobile">
        <v-card variant="outlined" :class="isOnMobile ? 'ma-0 pa-0' : 'ma-2 pa-0'" :height="isOnMobile ? 220 : 260" width="auto">
          <chart-simple-line v-if="datatypeChartDaily" :datatype="datatypeChartDaily" class="ma-0 mx-2 pa-0"></chart-simple-line>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="ma-0 pa-0" justify="center">
      <v-col class="ma-0 pa-2 d-flex" cols="12" sm="12" md="6" lg="4" xl="4">
        <v-card variant="outlined" :class="isOnMobile ? 'ma-0 pa-2 px-8' : 'ma-2 pa-2 px-8'" justify="space-between" :min-width="320" style="flex: 1 0 auto">
          <v-card-title :class="IF.MyFontTitle">За деня:</v-card-title>

          <v-row class="ma-1 pa-0" align="center">
            <v-icon color="green" :size="IF.MyIconSize">mdi-account-cash-outline</v-icon>
            <v-card-title :class="IF.MyFont">
              {{ "Оборот за деня: " + getDailySum.toFixed(2) + " €" }}
            </v-card-title>
          </v-row>
          <v-row class="ma-1 pa-0" align="center">
            <v-icon color="green" :size="IF.MyIconSize" style="cursor: pointer" @click="$router.push({ name: 'Transactions' })">mdi-car-multiple</v-icon>
            <v-card-title :class="IF.MyFont">
              {{ "Заряди за деня: " + getDailyChargesCount + " бр." }}
            </v-card-title>
          </v-row>
        </v-card>
      </v-col>
      <v-col class="ma-0 pa-2 d-flex" cols="12" sm="12" md="6" lg="4" xl="4">
        <v-card variant="outlined" :class="isOnMobile ? 'ma-0 pa-2 px-8' : 'ma-2 pa-2 px-8'" :min-width="320" style="flex: 1 1 auto">
          <v-card-title :class="IF.MyFontTitle">Текущо състояние:</v-card-title>
          <v-row class="ma-1 pa-0" align="center">
            <v-icon
              :size="IF.MyIconSize"
              :color="getOfflineCount ? 'red' : Colors.IconColor"
              style="cursor: pointer"
              @click="$router.push({ name: 'CurrentState', query: { filter: getOfflineCount ? 'Offline' : 'Online' } })"
              >mdi-ev-station</v-icon
            >
            <v-card-title :class="IF.MyFont">
              {{ "Online станции: " + getOnlineCount + "/" + (getOnlineCount + getOfflineCount) }}
            </v-card-title>
          </v-row>

          <v-row class="ma-1 pa-0" align="center">
            <v-icon :size="IF.MyIconSize" :color="getOnlineFDCount == getUniqueFDCount ? Colors.IconColor : 'red'">mdi-credit-card-outline</v-icon>
            <v-card-title :class="IF.MyFont">
              {{ "POS Терминали: " + getOnlineFDCount + "/" + getUniqueFDCount }}
            </v-card-title>
          </v-row>
          <v-row v-if="getOfflineConnectorsCount" class="ma-1 pa-0" align="center">
            <v-icon color="red" :size="IF.MyIconSize">mdi-ev-plug-ccs2</v-icon>
            <v-card-title :class="IF.MyFont">
              {{ "Дефектирал конектор: " + getOfflineConnectorsCount }}
            </v-card-title>
          </v-row>
          <v-row class="ma-1 pa-0" align="center">
            <v-icon color="green" :size="IF.MyIconSize" @click="$router.push({ name: 'CurrentState', query: { filter: 'Активни' } })">
              mdi-car-electric-outline
            </v-icon>
            <v-card-title :class="IF.MyFont">
              {{ "В момента зареждат: " + getChargingCount.toFixed(0) }}
            </v-card-title>
          </v-row>
          <v-row class="ma-1 pa-0" align="center">
            <v-icon color="green" :size="IF.MyIconSize">mdi-flash</v-icon>
            <v-card-title :class="IF.MyFont">
              {{ "Натоварване: " + getCurrentChargeRate.toFixed(3) + " KWh" }}
            </v-card-title>
          </v-row>
        </v-card>
      </v-col>
      <v-col class="ma-0 pa-2 d-flex" cols="12" sm="12" md="6" lg="4" xl="4">
        <v-card variant="outlined" :class="isOnMobile ? 'ma-0 pa-2 px-8' : 'ma-2 pa-2 px-8'" :min-width="320" style="flex: 1 1 auto">
          <v-card-title :class="IF.MyFontTitle">Текущи цени:</v-card-title>
          <v-row class="ma-1 pa-0" align="center" v-if="getPrice(false)">
            <v-icon color="green" :size="IF.MyIconSize"> mdi-ev-plug-ccs2</v-icon>
            <v-card-title :class="IF.MyFont">
              {{ "DC станции: " + getPrice(false) }}
            </v-card-title>
          </v-row>
          <v-row class="ma-1 pa-0" align="center" v-if="getPrice(true)">
            <v-icon color="green" :size="IF.MyIconSize">mdi-ev-plug-type2</v-icon>
            <v-card-title :class="IF.MyFont">
              {{ "AC станции: " + getPrice(true) }}
            </v-card-title>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        v-if="
          (DataManager.user.userType == DataManager.UserTypes.Owner || DataManager.user.userType == DataManager.UserTypes.OnwerWithPermissions) &&
          invoicingTitle
        "
        class="ma-0 pa-2 d-flex"
        cols="12"
        sm="12"
        md="6"
        lg="4"
        xl="4"
      >
        <v-card variant="outlined" :class="isOnMobile ? 'ma-0 pa-2 px-8' : 'ma-2 pa-2 px-8'" :min-width="320" style="flex: 1 1 auto">
          <v-card-title :class="IF.MyFontTitle">
            {{ invoicingTitle }}
          </v-card-title>
          <v-row class="ma-1 pa-0" align="center">
            <v-icon color="green" :size="IF.MyIconSize">mdi-book-check-outline</v-icon>
            <v-card-title :class="IF.MyFontTitle" style="white-space: pre">
              {{ invoicingText }}
            </v-card-title>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DataManager from "@/data/DataManager";
import ChartSimpleDonut from "./ChartSimpleDonut.vue";
import ChargeStationStatus from "@/js/ChargeStationStatus";
import ChargeStationConnectorStatus from "@/js/ChargeStationConnectorStatus";
import ChartSimpleLine from "./ChartSimpleLine.vue";
import { g_Events } from "@/main";

export default {
  components: {
    ChartSimpleDonut,
    ChartSimpleLine,
  },
  data: () => ({
    stations: [],
    datatypeChartMonthly: null,
    datatypeChartDaily: null,
    invoicingTitle: "",
    invoicingText: "",
    DataManager: DataManager,
  }),
  computed: {
    getOnlineCount() {
      return this.stations.filter((s) => s.Status == ChargeStationStatus.Online).length;
    },
    getOfflineCount() {
      return this.stations.filter((s) => s.Status == ChargeStationStatus.Offline).length;
    },
    getUniqueFDs() {
      return this.stations
        .filter((s) => s.fd && !!s.fd.sn)
        .map((s) => s.fd)
        .unique();
    },

    getUniqueFDCount() {
      return this.getUniqueFDs.length;
    },
    getOnlineFDCount() {
      return this.getUniqueFDs.filter((fd) => !fd.displayFailedLastTry).length;
    },
    getOfflineConnectorsCount() {
      var connectors = Object.values([].concat(...this.stations.map((s) => [...Object.values(s.onlineConnectors)])));
      var defect = connectors.filter((c) => c.statusNotifReqStr == ChargeStationConnectorStatus.Faulted).length;
      return defect;
    },
    getChargingCount() {
      var connectors = Object.values([].concat(...this.stations.filter((s) => s.IsOnline).map((s) => [...Object.values(s.onlineConnectors)])));
      var charges = connectors.filter((c) => c.statusNotifReqStr == ChargeStationConnectorStatus.Charging).length;
      return charges;
    },
    getDailySum() {
      return this.stations
        .filter((s) => !!s.SumToday)
        .map((s) => s.SumToday)
        .sum();
    },
    getCurrentChargeRate() {
      return this.stations
        .filter((v) => !!v.ChargeRateKW)
        .map((s) => s.ChargeRateKW)
        .sum();
    },
    getDailyChargesCount() {
      return this.stations.map((s) => s.ChargesToday).sum() ?? 0;
    },
  },
  methods: {
    async setMeta(meta, err) {
      this.datatype = meta.datatype;
      if (err.success && !err.message) {
        this.stations = [...(this.datatype.data ?? [])];
        this.datatype.isLoading = false;

        await DataManager.loadData(DataManager.data.ChartMonthly);
        await DataManager.data.ChartMonthly.generateChartData();
        this.datatypeChartMonthly = DataManager.data.ChartMonthly;

        await DataManager.loadData(DataManager.data.ChartDaily, undefined, false, {
          from: new Date().getFirstDayOfMonth().toStringWithFormat("dd-MM-yyyy HH:mm"),
          to: new Date().getDate235959().toStringWithFormat("dd-MM-yyyy HH:mm"),
        });

        await DataManager.data.ChartDaily.generateChartData();
        this.datatypeChartDaily = DataManager.data.ChartDaily;

        // if (this.isOnTestServer) {
        var dt = new Date().addMonths(-1);
        await DataManager.loadData(DataManager.data.ForInvoicing, undefined, false, {
          month: (dt.getMonth() + 1).toString().padStart(2, "0") + "-" + dt.getFullYear(),
        });
        var ddt = DataManager.getData(DataManager.data.ForInvoicing);

        if (ddt && ddt.length > 0) {
          var data = ddt.groupByAndSum(["Month", "Year"], "ForInvoicing")[0];
          this.invoicingTitle = "За фактуриране (с ДДС):";
          this.invoicingText = data.Month + " " + data.Year + "\n" + data.ForInvoicing.toFixed(2) + " €";
        }
        // }
      } else {
        this.datatype.errorMessage = err.message;
        this.datatype.isLoading = false;
      }
    },

    getPrice(ac) {
      var prices = this.stations.filter((s) => s.Price && s.PowerType == (ac ? "AC" : "DC")).map((s) => s.Price);
      if (prices.length == 0) {
        return "";
      }
      // console.log(prices);
      var min = Math.min(...prices);
      var max = Math.max(...prices);
      return min.toFixed(2) + (min == max ? "" : " - " + max.toFixed(2)) + " €";
    },
  },
  mounted() {
    this.bus.on(g_Events.ChargeStationRefresh, () => {
      this.stations = DataManager.getData(DataManager.data.ChargeStation, true);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    });
  },
};
</script>

<style>
</style>